// extracted by mini-css-extract-plugin
export default {"header":"header-I7vbZ","title":"title-D8Xdp","body":"body-sBEaa","description":"description-nhS9T","enableShortcuts":"enableShortcuts-gbdQM"};